import React from 'react';

export default function PriceChange({ change, changePercent, size = 'md' }) {
  if (change == null || changePercent == null) {
    return <span className="price-change muted">Unavailable</span>;
  }
  const up = change >= 0;
  return (
    <span className={`price-change ${up ? 'up' : 'down'} ${size}`}>
      {up ? '+' : ''}
      {change.toFixed(2)} ({up ? '+' : ''}
      {changePercent.toFixed(2)}%)
    </span>
  );
}
